export default __webpack_public_path__ + "php.330ff75d.png";